import { render, staticRenderFns } from "./PrkBeamSyllabusesList.vue?vue&type=template&id=5bdce51b&scoped=true&"
import script from "./PrkBeamSyllabusesList.vue?vue&type=script&lang=js&"
export * from "./PrkBeamSyllabusesList.vue?vue&type=script&lang=js&"
import style0 from "./PrkBeamSyllabusesList.vue?vue&type=style&index=0&id=5bdce51b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdce51b",
  null
  
)

export default component.exports